/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Policy_LeadInputs */

const en_price_page_policy_lead = /** @type {(inputs: Price_Page_Policy_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cancellation rules up front.`)
};

const pl_price_page_policy_lead = /** @type {(inputs: Price_Page_Policy_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zasady odwołania z góry.`)
};

/**
* | output |
* | --- |
* | "The cancellation rules up front." |
*
* @param {Price_Page_Policy_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_policy_lead = /** @type {((inputs?: Price_Page_Policy_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Policy_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_policy_lead(inputs)
	return en_price_page_policy_lead(inputs)
});